import Button from "@mui/material/Button";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Paper from '@mui/material/Paper';
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from "@mui/material/TextField";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Link from "@mui/material/Link";
import { styled } from '@mui/material/styles';

import React, {useEffect, useState} from "react";
import axios from "axios";
import {useLocation, useNavigate} from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import HeaderBar from "../components/HeaderBar";
import {jwtDecode} from "jwt-decode";

import dayjs, { Dayjs } from 'dayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

function ViewRGA() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { state } = useLocation();
  const { rga_number } = state;
  const [claimNum, setClaimNum] = useState(-1);
  const [companyName, setCompanyName] = useState("");
  const [custContactFirstName, setCustContactFirstName] = useState("");
  const [custContactLastName, setCustContactLastName] = useState("");
  const [custClaimNum, setCustClaimNum] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [status, setStatus] = useState(-1);
  const [statusString, setStatusString] = useState("");
  const [importStatus, setImportStatus] = useState(-1);
  const [importErrorStatus, setImportErrorStatus] = useState(false);
  const [importStatusString, setImportStatusString] = useState("");
  const [emailConfStatus, setEmailConfStatus] = useState(-1);
  const [emailConfStatusString, setEmailConfStatusString] = useState("");
  const [importDate, setImportDate] = useState(null);

  const [rcpPN, setRcpPN] = useState("");
  const [custPN, setCustPN] = useState("");
  const [custReturnCompName, setCustReturnCompName] = useState("");
  const [custReturnName, setCustReturnName] = useState("");
  const [custReturnAddr, setCustReturnAddr] = useState("");
  const [custReturnAddr2, setCustReturnAddr2] = useState("");
  const [custReturnCity, setCustReturnCity] = useState("");
  const [custReturnState, setCustReturnState] = useState("");
  const [custReturnZip, setCustReturnZip] = useState("");
  const [custReturnCountry, setCustReturnCountry] = useState("");
  const [purchOrderNum, setPurchOrderNum] = useState("");

  const [quantity, setQuantity] = useState("");
  const [entriesList, setEntriesList] = useState([]);
  const [rgaImageFiles, setRgaImageFiles] = useState([]);
  // const [rgaImages, setRgaImages] = useState([]);

  const [emptyStatus, setEmptyStatus] = useState(false);
  const [disposition, setDisposition] = useState("");

  const [scrapDialogOpen, setScrapDialogOpen] = useState(false);
  const [scrapEmailBodyEmptyError, setScrapEmailBodyEmptyError] = useState(false);
  const [scrapEmailBody, setScrapEmailBody] = useState("This is a notification that RGA # has been issued. " +
      "Please scrap the following parts for RGA # ")
  const [returnDialogOpen, setReturnDialogOpen] = useState(false);
  const [returnEmailBodyEmptyError, setReturnEmailBodyEmptyError] = useState(false);
  const [returnEmailBody, setReturnEmailBody] = useState("This is a notification that RGA # has been issued. " +
      "Please return the following parts for RGA # : Please reference RGA # on the box and all return paperwork.")
  const [missingPartsDialogOpen, setMissingPartsDialogOpen] = useState(false);
  const [missingPartsEmailBodyEmptyError, setMissingPartsEmailBodyEmptyError] = useState(false);
  const [missingPartsEmailBody, setMissingPartsEmailBody] = useState("This is a notification that RGA # has been issued. Parts will be sent to you as soon as they are in stock.")
  const [dialogSubmitDisabled, setDialogSubmitDisabled] = useState(false);

  const [redirectShipmentDialogOpen, setRedirectShipmentDialogOpen] = useState(false);
  const [redirectShipmentEmailBodyEmptyError, setRedirectShipmentEmailBodyEmptyError] = useState(false);
  const [redirectShipmentEmailBody, setRedirectShipmentEmailBody] = useState("This is a notification that RGA # has been issued. The shipping concerns will be addressed.")

  const [openEmailSuccessSnackbar, setOpenEmailSuccessSnackbar] = useState(false);
  const [openEmailErrorSnackbar, setOpenEmailErrorSnackbar] = useState(false);
  const [openImportSuccessSnackbar, setOpenImportSuccessSnackbar] = useState(false);
  const [openImportErrorSnackbar, setOpenImportErrorSnackbar] = useState(false);
  const [openCompleteSuccessSnackbar, setOpenCompleteSuccessSnackbar] = useState(false);
  const [openCompleteErrorSnackbar, setOpenCompleteErrorSnackbar] = useState(false);

  const [openCancelSuccessSnackbar, setOpenCancelSuccessSnackbar] = useState(false);
  const [openCancelErrorSnackbar, setOpenCancelErrorSnackbar] = useState(false);

  const [cancelClaimDialogOpen, setCancelClaimDialogOpen] = useState(false);

  const handleDispositionChange = (event) =>{
      setDisposition(event.target.value);
  }

  const handleEmailSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenEmailSuccessSnackbar(false);
  };

  const handleEmailErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenEmailErrorSnackbar(false);
  };

  const handleImportSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenImportSuccessSnackbar(false);
  };

  const handleImportErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenImportErrorSnackbar(false);
  };

  const handleCompleteSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenCompleteSuccessSnackbar(false);
  };

  const handleCompleteErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenCompleteErrorSnackbar(false);
  };

  const handleCancelSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenCancelSuccessSnackbar(false);
  };

  const handleCancelErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenCancelErrorSnackbar(false);
  };

  const handleScrap = (event) => {
      setScrapDialogOpen(true);
  }

  const handleScrapClose = (event) => {
      setScrapDialogOpen(false);
  }

  const handleScrapSubmit = async (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      if (data.get("s_emailbody").length === 0) {
          setScrapEmailBodyEmptyError(true);
      }
      else {
          setDialogSubmitDisabled(true);
          setScrapEmailBodyEmptyError(false);
          const s_emailccs = data.get("s_emailcc");
          const s_emailbccs = data.get("s_emailbcc");
          const s_emailbody = data.get("s_emailbody");
          await axios.post('/api/emailscraprga', {
              rga_number: claimNum,
              email_conf_status: 1,
              s_emailccs: s_emailccs,
              s_emailbccs: s_emailbccs,
              s_emailbody: s_emailbody,
          }).then(function (response) {
              // console.log(response);
              if (response.status === 200) {
                  setOpenEmailSuccessSnackbar(true);
                  // navigate(0);
                  // navigate('/view_rga', { state: { rga_number: response.data.claim_id } });
              }
          }).catch(function (error) {
              console.log(error);
              setOpenEmailErrorSnackbar(true);
          });
      }
  }

  const handleReturn = (event) => {
      setReturnDialogOpen(true);
  }

  const handleReturnClose = (event) => {
      setReturnDialogOpen(false);
  }

  const handleReturnSubmit = async (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      if (data.get("r_emailbody").length === 0) {
          setReturnEmailBodyEmptyError(true);
      }
      else {
          setDialogSubmitDisabled(true);
          setReturnEmailBodyEmptyError(false);
          const r_emailccs = data.get("r_emailcc");
          const r_emailbccs = data.get("r_emailbcc");
          const r_emailbody = data.get("r_emailbody");
          await axios.post('/api/emailreturnrga', {
              rga_number: claimNum,
              email_conf_status: 2,
              r_emailccs: r_emailccs,
              r_emailbccs: r_emailbccs,
              r_emailbody: r_emailbody,
          }).then(function (response) {
              // console.log(response);
              if (response.status === 200) {
                  setOpenEmailSuccessSnackbar(true);
                  // navigate(0);
                  // navigate('/view_rga', { state: { rga_number: response.data.claim_id } });
              }
          }).catch(function (error) {
              console.log(error);
              setOpenEmailErrorSnackbar(true);
          });
      }
  }

  const handleMissingParts = (event) => {
      setMissingPartsDialogOpen(true);
  }

  const handleMissingPartsClose = (event) => {
      setMissingPartsDialogOpen(false);
  }

  const handleMissingPartsSubmit = async (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      if (data.get("m_emailbody").length === 0) {
          setMissingPartsEmailBodyEmptyError(true);
      }
      else {
          setDialogSubmitDisabled(true);
          setMissingPartsEmailBodyEmptyError(false);
          const m_emailccs = data.get("m_emailcc");
          const m_emailbccs = data.get("m_emailbcc");
          const m_emailbody = data.get("m_emailbody");
          await axios.post('/api/emailmissingpartsrga', {
              rga_number: claimNum,
              email_conf_status: 3,
              m_emailccs: m_emailccs,
              m_emailbccs: m_emailbccs,
              m_emailbody: m_emailbody,
          }).then(function (response) {
              // console.log(response);
              if (response.status === 200) {
                  setOpenEmailSuccessSnackbar(true);
                  // navigate(0);
                  // navigate('/view_rga', { state: { rga_number: response.data.claim_id } });
              }
          }).catch(function (error) {
              console.log(error);
              setOpenEmailErrorSnackbar(true);
          });
      }
  }

  const handleRedirectShipment = (event) => {
      setRedirectShipmentDialogOpen(true);
  }

  const handleRedirectShipmentClose = (event) => {
      setRedirectShipmentDialogOpen(false);
  }

  const handleRedirectShipmentSubmit = async (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      if (data.get("rs_emailbody").length === 0) {
          setRedirectShipmentEmailBodyEmptyError(true);
      }
      else {
          setDialogSubmitDisabled(true);
          setRedirectShipmentEmailBodyEmptyError(false);
          const rs_emailccs = data.get("rs_emailcc");
          const rs_emailbccs = data.get("rs_emailbcc");
          const rs_emailbody = data.get("rs_emailbody");
          await axios.post('/api/emailredirectshipmentrga', {
              rga_number: claimNum,
              email_conf_status: 4,
              rs_emailccs: rs_emailccs,
              rs_emailbccs: rs_emailbccs,
              rs_emailbody: rs_emailbody,
          }).then(function (response) {
              // console.log(response);
              if (response.status === 200) {
                  setOpenEmailSuccessSnackbar(true);
                  // navigate(0);
                  // navigate('/view_rga', { state: { rga_number: response.data.claim_id } });
              }
          }).catch(function (error) {
              console.log(error);
              setOpenEmailErrorSnackbar(true);
          });
      }
  }

  const handleImport = async (event) => {
      if (emailConfStatus === 0) {
          setImportErrorStatus(true);
      }
      else {
          setImportErrorStatus(false);
          await axios.post('/api/importrga', {
              rga_number: claimNum,
              import_status: "1",
          }).then(function (response) {
              // console.log(response);
              if (response.status === 200) {
                  setImportDate(dayjs(response.data.imported_date))
                  setOpenImportSuccessSnackbar(true);
                  // navigate(0);
                  // navigate('/view_rga', { state: { rga_number: response.data.claim_id } });
              }
          }).catch(function (error) {
              console.log(error);
              setOpenImportErrorSnackbar(true);
          });
      }
  }

  const completeClaim = async (event) => {
      if (disposition === "") {
          setEmptyStatus(true);
      }
      else {
          setEmptyStatus(false);
          await axios.post('/api/completerga', {
              rga_number: claimNum,
              status: "1",
              disposition: disposition,
          }).then(function (response) {
              // console.log(response);
              if (response.status === 200) {
                  navigate(0);
                  setOpenCompleteSuccessSnackbar(true);
                  // navigate('/view_rga', { state: { rga_number: response.data.claim_id } });
              }
          }).catch(function (error) {
              console.log(error);
              setOpenCompleteErrorSnackbar(true);
          });
      }
  }

  const handleCancelClaimDialogOpen = (event) => {
      setCancelClaimDialogOpen(true);
  }

  const handleCancelClaimDialogClose = (event) => {
      setCancelClaimDialogOpen(false);
  }

  const cancelClaim = async (event) => {
      event.preventDefault();
      setDialogSubmitDisabled(true);
      setCancelClaimDialogOpen(false);
      await axios.post('/api/cancelrga', {
          rga_number: claimNum,
          status: "2",
      }).then(function (response) {
          // console.log(response);
          if (response.status === 200) {
              navigate(0);
              setOpenCancelSuccessSnackbar(true);
              // navigate('/view_rga', { state: { rga_number: response.data.claim_id } });
          }
      }).catch(function (error) {
          console.log(error);
          setOpenCancelErrorSnackbar(true);
      });
  }

  const handleDownloadZip = async (event) => {
      await axios.post('/api/getrgaimagezips', {
          rga_number: rga_number,
      }, {
          responseType: 'blob',
      }).then(function (response) {
          if (response.status === 200) {
              console.log(response);
              // let zip_file = response.data.zipfile;
              // let filename = response.data.filename;
              let url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/zip'}));
              let link = document.createElement('a');
              link.href = url;
              let filename = rga_number.toString() + '.zip'
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();

              document.body.removeChild(link);
              URL.revokeObjectURL(url);
          }
      }).catch(function (error) {
          console.log(error);
          //setOpenCompleteErrorSnackbar(true);
      });
  }

  useEffect( () => {
      // console.log(rga_number);
      axios.post('/api/viewrga', {
              rga_number: rga_number,
          }).then(function (response) {
              // console.log(response);
              if (response.status === 200) {
                  const rga_data = response.data.rga;
                  setClaimNum(rga_data.id);
                  setCompanyName(rga_data.cust_company_name);
                  setCustContactFirstName(rga_data.cust_first_name);
                  setCustContactLastName(rga_data.cust_last_name);
                  setCustClaimNum(rga_data.cust_claim_num);
                  setEmail(rga_data.cust_email);
                  setPhoneNum(rga_data.phone_num);

                  setRcpPN(rga_data.pn);
                  setCustPN(rga_data.cust_pn);
                  setCustReturnCompName(rga_data.cust_ret_comp_name);
                  setCustReturnName(rga_data.cust_ret_name);
                  setCustReturnAddr(rga_data.cust_ret_addr);
                  setCustReturnAddr2(rga_data.cust_ret_addr_2);
                  setCustReturnCity(rga_data.cust_ret_city);
                  setCustReturnState(rga_data.cust_ret_state);
                  setCustReturnZip(rga_data.cust_ret_zip);
                  setCustReturnCountry(rga_data.cust_ret_country);
                  setPurchOrderNum(rga_data.purch_order_num);
                  setQuantity(response.data.quantity);
                  setStatus(rga_data.status);
                  setImportStatus(rga_data.import_status);
                  setEmailConfStatus(rga_data.email_conf_status);
                  setImportDate(dayjs(rga_data.imported_date));

                  setScrapEmailBody("This is a notification that RGA # " + rga_data.id + " has been issued. " +
                                    "Please scrap the following parts for RGA # " + rga_data.id)
                  setReturnEmailBody("RGA # " + rga_data.id + " has been issued for the return of " +
                                    "(" + response.data.quantity + ") " + rga_data.pn + " part number. " +
                                    "Please package the unit well to prevent further damage. " +
                                    "Please reference RGA # " + rga_data.id + " on the box and all return paperwork. " +
                                    "Please ship the unit via R&L Carriers (account SRF731) or USP (account Y97365) to:\n\n"
                                    + "Richardson Cooling Packages, LLC\nc/o Quality Department - RGA (" + rga_data.id + ")\n" +
                                    "1900 New Butler Road\nNew Castle, PA 16101\n")
                  setMissingPartsEmailBody("This is a notification that RGA # " + rga_data.id + " has been issued. " +
                                    "Parts will be sent to you as soon as they are in stock.")
                  setRedirectShipmentEmailBody("This is a notification that RGA # " + rga_data.id + " has been issued. " +
                      "The shipping concerns will be addressed.")

                  if (rga_data.status === 0) {
                      setStatusString("Pending");
                  }
                  else if (rga_data.status === 1) {
                      setStatusString("Completed");
                      setDisposition(rga_data.disposition);
                  }
                  else if (rga_data.status === 2) {
                      setStatusString("Cancelled");
                  }
                  // else if (rga_data.status === 2) {
                  //     setStatusString("Rejected");
                  //     setDisposition(rga_data.disposition);
                  // }

                  if (rga_data.import_status === 0) {
                      setImportStatusString("Pending");
                  }
                  else if (rga_data.import_status === 1) {
                      setImportStatusString("Complete");
                  }

                  if (rga_data.email_conf_status === 0) {
                      setEmailConfStatusString("Pending");
                  }
                  else if (rga_data.email_conf_status === 1) {
                      setEmailConfStatusString("Scrap");
                  }
                  else if (rga_data.email_conf_status === 2) {
                      setEmailConfStatusString("Return");
                  }
                  else if (rga_data.email_conf_status === 3) {
                      setEmailConfStatusString("Parts Missing");
                  }
                  else if (rga_data.email_conf_status === 4) {
                      setEmailConfStatusString("Redirect Shipment");
                  }

                  const rga_serial_num_entries = response.data.rga_serial_nums;
                  let new_entries = [];
                  new_entries.push(<Grid item xs={2}>
                        <Item>RCP Serial Number(s):</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2}>
                        <Item>Customer Defect Code(s):</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2}>
                        <Item>Production Date(s):</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2}>
                        <Item>In Service Date(s):</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2}>
                        <Item>In Service Hours:</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2}>
                        <Item>Description(s):</Item>
                      </Grid>);
                  for (let i=0; i<rga_serial_num_entries.length; i++) {
                      const entry = rga_serial_num_entries[i];
                      // Add Code to make Grid items for each dictionary
                      new_entries.push(<Grid item xs={2}>
                            <Item>{entry.serial_num}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2}>
                            <Item>{entry.defect_code}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2}>
                            <Item>{entry.prod_date}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2}>
                            <Item>{entry.in_serv_date}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2}>
                            <Item>{entry.in_serv_hours}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2}>
                            <Item>{entry.desc}</Item>
                          </Grid>);
                  }
                  setEntriesList(new_entries);
                  // Modify to accept the single zip file as a link
                  let filenames = response.data.filenames;
                  let temp_links = [];
                  for (let i=0; i<filenames.length; i++) {
                      temp_links.push(<Button component={Link} onClick={handleDownloadZip}>{filenames[i]}</Button>)
                  }
                  setRgaImageFiles(temp_links);
                  // let images = response.data.images;
                  // let filenames = response.data.filenames;
                  // let temp_imgs = [];
                  // for (let i=0; i<images.length; i++) {
                  //     // console.log(filenames[i]);
                  //     const filename = filenames[i];
                  //     const filename_arr = filename.split(".");
                  //     const extension = filename_arr[filename_arr.length - 1];
                  //     if (extension === "jpg") {
                  //         const image = new Image();
                  //         image.title = filename
                  //         image.src = 'data:image/jpg;base64,' + images[i];
                  //         temp_imgs.push(image);
                  //     }
                  //     else if (extension === "jpeg") {
                  //         const image = new Image();
                  //         image.title = filename
                  //         image.src = 'data:image/jpeg;base64,' + images[i];
                  //         temp_imgs.push(image);
                  //     }
                  //     else if (extension === "png") {
                  //         const image = new Image();
                  //         image.title = filename
                  //         image.src = 'data:image/png;base64,' + images[i];
                  //         temp_imgs.push(image);
                  //     }
                  // }
                  // setRgaImages(temp_imgs);
              }
          })
          .catch(function (error) {
              console.log(error);
              console.log(error.response);
              console.log(error.response.data);
          });
  }, []);

  // useEffect(() => {
  //     console.log(rga_number);
  //     axios.post('/api/viewrgaimages', {
  //             rga_number: rga_number,
  //         }).then(function (response) {
  //             console.log(response);
  //             let images = response.data.images;
  //             let filenames = response.data.filenames;
  //             let temp_imgs = [];
  //             for (let i=0; i<images.length; i++) {
  //                 console.log(filenames[i]);
  //                 const filename = filenames[i];
  //                 const filename_arr = filename.split(".");
  //                 const extension = filename_arr[filename_arr.length - 1];
  //                 console.log(filename);
  //                 console.log(filename_arr);
  //                 console.log(extension);
  //                 if (extension === "jpg") {
  //                     const image = new Image();
  //                     image.title = filename
  //                     image.src = 'data:image/jpg;base64,' + images[i];
  //                     temp_imgs.push(image);
  //                 }
  //                 else if (extension === "jpeg") {
  //                     const image = new Image();
  //                     image.title = filename
  //                     image.src = 'data:image/jpeg;base64,' + images[i];
  //                     temp_imgs.push(image);
  //                 }
  //                 else if (extension === "png") {
  //                     const image = new Image();
  //                     image.title = filename
  //                     image.src = 'data:image/png;base64,' + images[i];
  //                     temp_imgs.push(image);
  //                 }
  //             }
  //             setRgaImages(temp_imgs);
  //         })
  //         .catch(function (error) {
  //             console.log(error);
  //         });
  // }, []);

  return (
      <Box>
          <HeaderBar />
          <Stack direction='column' spacing={2}>
              <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                <Typography variant="h4" gutterBottom> RGA: #{rga_number}</Typography>
              </Box>
              {emailConfStatus === 0 ? <Stack spacing={2}>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>Email Confirmation Status: {emailConfStatusString}</Box>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      <Button variant="contained" onClick={handleReturn}>Ship Back to RCP</Button>
                      <Button variant="contained" onClick={handleMissingParts}>Parts are Missing (No Shipment Back)</Button>
                      <Button variant="contained" onClick={handleScrap}>Customer Scraps on Site</Button>
                      <Button variant="contained" onClick={handleRedirectShipment}>Redirect Shipment</Button>
                    </Box>
              </Stack> : <Stack spacing={2}>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>Email Confirmation Status: {emailConfStatusString}</Box>
              </Stack>}
              {importStatus === 0 && emailConfStatus !== 0 ? <Stack spacing={2}>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>Import Status: {importStatusString}</Box>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      <Button variant="contained" onClick={handleImport}>Import</Button>
                    </Box>
              </Stack> : <Stack spacing={2}>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>Import Status: {importStatusString}</Box>
                  {importStatus !== 0 ? <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateField label="Imported Date" value={importDate} readOnly/>
                      </LocalizationProvider>
                  </Box> : <Box></Box>}
              </Stack>}
              {importErrorStatus === true ? <Box>
                  Error, you must send an email confirmation first before importing the claim into Odoo.
              </Box> : ''}
              {status === 0 ? <Stack spacing={2}>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>Status: {statusString}</Box>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      <Button variant="contained" onClick={completeClaim}>Complete</Button>
                    </Box>
                  <Box>
                      <Stack alignItems="stretch" justifyContent="flex-end">
                          <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>Disposition:</Box>
                          <TextField
                              margin="normal"
                              id="dispositon"
                              label="Disposition"
                              name="disposition"
                              multiline
                              error={emptyStatus}
                              rows={6}
                              onChange={handleDispositionChange}
                              required
                              helperText={emptyStatus ? "The disposition cannot be left empty for RGA completion" : ""}
                          />
                      </Stack>
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      <Button variant="contained" onClick={handleCancelClaimDialogOpen}>Cancel</Button>
                    </Box>
              </Stack> : <Stack>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>Status: {statusString}</Box>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>Disposition: {disposition}</Box>
              </Stack>}
              <Card>
                  <CardHeader title="Company Information:"></CardHeader>
                  <CardContent>
                      <Stack spacing={3}>
                          <Item>Company Claim Number: {custClaimNum}</Item>
                          <Item>Company Name: {companyName}</Item>
                          <Item>First Name: {custContactFirstName}</Item>
                          <Item>Last Name: {custContactLastName}</Item>
                          <Item>Phone Number: {phoneNum}</Item>
                          <Item>Email: {email}</Item>
                      </Stack>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Return Shipping Information:"></CardHeader>
                  <CardContent>
                      <Stack spacing={3}>
                          <Item>Company Name: {custReturnCompName}</Item>
                          <Item>Full Name: {custReturnName}</Item>
                          <Item>Address: {custReturnAddr}</Item>
                          <Item>Address 2: {custReturnAddr2}</Item>
                          <Item>City: {custReturnCity}</Item>
                          <Item>State: {custReturnState}</Item>
                          <Item>Zip: {custReturnZip}</Item>
                          <Item>Country: {custReturnCountry}</Item>
                      </Stack>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Product Information:"></CardHeader>
                  <CardContent>
                      <Stack spacing={3}>
                          <Item>RCP PN: {rcpPN}</Item>
                          <Item>Customer PN: {custPN}</Item>
                          <Item>Purchase Order Number: {purchOrderNum}</Item>
                          <Item>Quantity: {quantity}</Item>
                          <Grid container direction="row" alignContent="center" alignItems="center" spacing={1}>
                              {entriesList.length > 0 && entriesList.map(
                                      (text_item) => text_item)}
                          </Grid>
                      </Stack>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Photos:"></CardHeader>
                  <CardContent>
                      {rgaImageFiles.map((rgaImageFile) => (
                          <Box>{rgaImageFile}</Box>
                      ))}
                    {/*  <ImageList sx={{ width: 500, height: 450 }} cols={3} rowHeight={164}>*/}
                    {/*      {rgaImages.map((rgaImage) => (*/}
                    {/*        <ImageListItem key={rgaImage.src}>*/}
                    {/*          <img*/}
                    {/*            srcSet={rgaImage.src}*/}
                    {/*            src={rgaImage.src}*/}
                    {/*            alt={rgaImage.title}*/}
                    {/*            loading="lazy"*/}
                    {/*          />*/}
                    {/*    </ImageListItem>))}*/}
                    {/*</ImageList>*/}
                  </CardContent>
              </Card>
          </Stack>
          <Dialog open={scrapDialogOpen} onClose={handleScrapClose} PaperProps={{
                component: 'form',
                onSubmit: handleScrapSubmit,
          }}>
            <DialogTitle>Scrap Email Form</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    For emails, please enter address each in its entirety with a comma and a space to separate
                    multiple email entries. e.g.: johnsmith123@gmail.com, janesmith123@gmail.com,
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="s_emailcc"
                    name="s_emailcc"
                    label="Email CC Address(es)"
                    fullWidth
                    variant="standard"
                  />
                <TextField
                    autoFocus
                    margin="dense"
                    id="s_emailbcc"
                    name="s_emailbcc"
                    label="Email BCC Address(es)"
                    fullWidth
                    variant="standard"
                  />
                <TextField
                      autoFocus
                      required
                      margin="dense"
                      id="s_emailbody"
                      label="Email Body"
                      name="s_emailbody"
                      multiline
                      rows={6}
                      fullWidth
                      variant="standard"
                      defaultValue={scrapEmailBody}
                      error={scrapEmailBodyEmptyError}
                      helperText={scrapEmailBodyEmptyError ? "The body of the email being sent out cannot be left empty." : ""}
                  />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleScrapClose}>Cancel</Button>
                <Button type="submit" disabled={dialogSubmitDisabled}>Submit</Button>
            </DialogActions>
          </Dialog>
          <Dialog open={returnDialogOpen} onClose={handleReturnClose} PaperProps={{
                component: 'form',
                onSubmit: handleReturnSubmit,
          }}>
            <DialogTitle>Return Email Form</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    For emails, please enter address each in its entirety with a comma and a space to separate
                    multiple email entries. e.g.: johnsmith123@gmail.com, janesmith123@gmail.com,
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="r_emailcc"
                    name="r_emailcc"
                    label="Email CC Address(es)"
                    fullWidth
                    variant="standard"
                  />
                <TextField
                    autoFocus
                    margin="dense"
                    id="r_emailbcc"
                    name="r_emailbcc"
                    label="Email BCC Address(es)"
                    fullWidth
                    variant="standard"
                  />
                <TextField
                      autoFocus
                      required
                      margin="dense"
                      id="r_emailbody"
                      label="Email Body"
                      name="r_emailbody"
                      multiline
                      rows={6}
                      fullWidth
                      variant="standard"
                      defaultValue={returnEmailBody}
                      error={returnEmailBodyEmptyError}
                      helperText={returnEmailBodyEmptyError ? "The body of the email being sent out cannot be left empty." : ""}
                  />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleReturnClose}>Cancel</Button>
                <Button type="submit" disabled={dialogSubmitDisabled}>Submit</Button>
            </DialogActions>
          </Dialog>
          <Dialog open={missingPartsDialogOpen} onClose={handleMissingPartsClose} PaperProps={{
                component: 'form',
                onSubmit: handleMissingPartsSubmit,
          }}>
            <DialogTitle>Missing Parts Email Form</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    For emails, please enter address each in its entirety with a comma and a space to separate
                    multiple email entries. e.g.: johnsmith123@gmail.com, janesmith123@gmail.com,
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="m_emailcc"
                    name="m_emailcc"
                    label="Email CC Address(es)"
                    fullWidth
                    variant="standard"
                  />
                <TextField
                    autoFocus
                    margin="dense"
                    id="m_emailbcc"
                    name="m_emailbcc"
                    label="Email BCC Address(es)"
                    fullWidth
                    variant="standard"
                  />
                <TextField
                      autoFocus
                      required
                      margin="dense"
                      id="m_emailbody"
                      label="Email Body"
                      name="m_emailbody"
                      multiline
                      rows={6}
                      fullWidth
                      variant="standard"
                      defaultValue={missingPartsEmailBody}
                      error={missingPartsEmailBodyEmptyError}
                      helperText={missingPartsEmailBodyEmptyError ? "The body of the email being sent out cannot be left empty." : ""}
                  />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleMissingPartsClose}>Cancel</Button>
                <Button type="submit" disabled={dialogSubmitDisabled}>Submit</Button>
            </DialogActions>
          </Dialog>
          <Dialog open={redirectShipmentDialogOpen} onClose={handleRedirectShipmentClose} PaperProps={{
                component: 'form',
                onSubmit: handleRedirectShipmentSubmit,
          }}>
            <DialogTitle>Redirect Shipment Email Form</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    For emails, please enter address each in its entirety with a comma and a space to separate
                    multiple email entries. e.g.: johnsmith123@gmail.com, janesmith123@gmail.com,
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="rs_emailcc"
                    name="rs_emailcc"
                    label="Email CC Address(es)"
                    fullWidth
                    variant="standard"
                  />
                <TextField
                    autoFocus
                    margin="dense"
                    id="rs_emailbcc"
                    name="rs_emailbcc"
                    label="Email BCC Address(es)"
                    fullWidth
                    variant="standard"
                  />
                <TextField
                      autoFocus
                      required
                      margin="dense"
                      id="rs_emailbody"
                      label="Email Body"
                      name="rs_emailbody"
                      multiline
                      rows={6}
                      fullWidth
                      variant="standard"
                      defaultValue={redirectShipmentEmailBody}
                      error={redirectShipmentEmailBodyEmptyError}
                      helperText={redirectShipmentEmailBodyEmptyError ? "The body of the email being sent out cannot be left empty." : ""}
                  />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleRedirectShipmentClose}>Cancel</Button>
                <Button type="submit" disabled={dialogSubmitDisabled}>Submit</Button>
            </DialogActions>
          </Dialog>
          <Dialog open={cancelClaimDialogOpen} onClose={handleCancelClaimDialogClose} PaperProps={{
                component: 'form',
                onSubmit: cancelClaim,
          }}>
            <DialogTitle>Cancel Claim</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to cancel this claim?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancelClaimDialogClose}>No</Button>
                <Button type="submit" disabled={dialogSubmitDisabled}>Yes</Button>
            </DialogActions>
          </Dialog>
          <Snackbar open={openEmailSuccessSnackbar} autoHideDuration={6000} onClose={handleEmailSuccessSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleEmailSuccessSnackbarClose} severity="success" variant="filled" sx={{ width: '100%' }}>
                  Success! Your email has been sent.
              </Alert>
          </Snackbar>
          <Snackbar open={openEmailErrorSnackbar} autoHideDuration={6000} onClose={handleEmailErrorSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleEmailErrorSnackbarClose} severity="error" variant="filled" sx={{ width: '100%' }}>
                  Error, something went wrong with your email.
              </Alert>
          </Snackbar>
          <Snackbar open={openImportSuccessSnackbar} autoHideDuration={6000} onClose={handleImportSuccessSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleImportSuccessSnackbarClose} severity="success" variant="filled" sx={{ width: '100%' }}>
                  Success! This RGA has imported.
              </Alert>
          </Snackbar>
          <Snackbar open={openImportErrorSnackbar} autoHideDuration={6000} onClose={handleImportErrorSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleImportErrorSnackbarClose} severity="error" variant="filled" sx={{ width: '100%' }}>
                  Error, something went wrong with your import.
              </Alert>
          </Snackbar>
          <Snackbar open={openCompleteSuccessSnackbar} autoHideDuration={6000} onClose={handleCompleteSuccessSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleCompleteSuccessSnackbarClose} severity="success" variant="filled" sx={{ width: '100%' }}>
                  Success! This RGA has been completed.
              </Alert>
          </Snackbar>
          <Snackbar open={openCompleteErrorSnackbar} autoHideDuration={6000} onClose={handleCompleteErrorSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleCompleteErrorSnackbarClose} severity="error" variant="filled" sx={{ width: '100%' }}>
                  Error, something went wrong with the completion of your RGA.
              </Alert>
          </Snackbar>
          <Snackbar open={openCancelSuccessSnackbar} autoHideDuration={6000} onClose={handleCancelSuccessSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleCancelSuccessSnackbarClose} severity="success" variant="filled" sx={{ width: '100%' }}>
                  This RGA has been cancelled.
              </Alert>
          </Snackbar>
          <Snackbar open={openCancelErrorSnackbar} autoHideDuration={6000} onClose={handleCancelErrorSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleCancelErrorSnackbarClose} severity="error" variant="filled" sx={{ width: '100%' }}>
                  Error, something went wrong with the cancelling of your RGA.
              </Alert>
          </Snackbar>
      </Box>
  );
}

export default ViewRGA;